import React from "react";

/**
 * ConnectionStatusCard — Shows platform connection readiness as a compact table.
 *
 * Props:
 *   data: {
 *     platforms: [{ platform, connection_type, status }],
 *     all_ready: boolean
 *   }
 *   onProceed: optional callback — shown when all_ready
 */
const ConnectionStatusCard = ({ data, onProceed }) => {
  if (!data || !data.platforms || data.platforms.length === 0) return null;
  
  if (!data.all_ready || !onProceed) return null;

  return (
    <div className="w-full flex justify-end my-2">
      <button
        onClick={onProceed}
        className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white text-[0.75rem] font-bold rounded-lg hover:bg-blue-700 transition active:scale-[0.97] shadow-sm"
      >
        Continue to Mapping
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default ConnectionStatusCard;
